import { css } from '@emotion/react';
import { colors, fancyBorder } from '../theme';
import { objectToCss } from '../utils/css';
import { onSm } from './responsive';

export const show = css`
  display: block;
`;

export const hidden = css`
  display: none;
`;

export const reset = css`
  margin: 0;
  display: block;
  padding: 0;
`;

export const scrollY = css`
  overflow-x: hidden;
  overflow-y: overlay;
`;

export const flex = css`
  display: flex;
  align-content: stretch;
  justify-content: space-between;
`;

export const transparent = css`
  background: transparent;
  border: none;
  outline: none;
`;

export const shadowAround = (theme) => css`
  box-shadow: 0 0 6px 0 ${theme.colors.shadow};
`;

export const blockquote = (theme) => css`
  font-size: 1.4em;
  width: 100%;
  margin: 30px auto;
  font-style: italic;
  color: ${theme.colors.font};
  padding: 14px 25px 14px 75px;
  border-left: 8px solid ${theme.colors.primary};
  line-height: 1.625;
  position: relative;
  background: ${theme.colors.border};

  &::before {
    content: '\\201C';
    color: ${theme.colors.primary};
    font-size: 4em;
    position: absolute;
    left: 10px;
    top: -13px;
  }

  &::after {
    content: '';
  }
  p {
    font-size: 15px;
  }
`;

export const pre = css`
  background-color: transparent;
  border: 0 !important;
  font-size: 14px;
  display: grid;
  pre.prism-code {
    margin: 0;
    padding: 16px;
    overflow: auto;
    border-radius: 4px;
  }
`;

export const table = (theme) => css`
  padding: 0;
  ${objectToCss(fancyBorder)};
  margin: 2px;
  border-spacing: 0;
  overflow-wrap: normal;
  ${onSm} {
    white-space: pre;
  }
  thead {
    color: ${colors.font};
    tr {
      font-weight: bold;
      text-align: left;
      th {
        margin: 0;
        padding: 9px 16px;
      }
    }
  }
  tbody tr {
    transition: ${theme.transitions.hover};
    margin: 0;
    padding: 0;
    &:nth-child(even) {
      background-color: ${theme.table.oddRow};
    }
    &:nth-child(odd) {
      background-color: ${theme.table.evenRow};
    }
    td {
      margin: 0;
      padding: 8px 15px;
    }
  }
  th :first-child,
  td :first-child {
    margin-top: 0;
  }
  th :last-child,
  td :last-child {
    margin-bottom: 0;
  }
`;

// export const scrollbar = css`
//   &::-webkit-scrollbar-track {
//     height: 9px;
//     width: 9px;
//     -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//     background-color: #f5f5f5;
//   }
//   &::-webkit-scrollbar {
//     height: 9px;
//     width: 9px;
//     background-color: #f5f5f5;
//   }
//   &::-webkit-scrollbar-thumb {
//     height: 9px;
//     width: 9px;
//     -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//     background-color: #555;
//   }
// `;

export const skipParagraph = css`
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

export const list = css`
  li {
    p {
      margin: 8px 0;
    }
    p:first-child {
      margin-top: 0;
    }
    p:last-child {
      margin-bottom: 0;
    }
    p:nth-child(n + 2):last-child {
      margin-bottom: 10px;
    }
  }
`;

export const hiddenMobile = css`
  ${onSm} {
    display: none;
  }
`;

export const visibleOnlyonSm = css`
  display: none;
  ${onSm} {
    display: flex;
  }
`;

export const dangerouslySetLongDescritpion = (theme) => css`
  table {
    ${table(theme)}
  }
  ${['warning', 'error', 'tip', 'info']
    .map(
      (boxType) => `
  .${boxType}-box {
    margin: 16px 0;
    padding: 14px;
    border: 1px solid ${theme.highlights[boxType].border};
    background-color: ${theme.highlights[boxType].background};
    color: ${theme.highlights[boxType].font};
    align-items: center;
    display: flex;
    border-radius: 4px;
    span,
    p {
      padding: 10px;
    }
  }
  `
    )
    .join('\n')}
`;

// export const insetBorder = ({ border }: { border: string }) => {
//   return {
//     '&:before': {
//       content: '" "' /* to ensure it displays */,
//       position: 'absolute',
//       left: '2.5px',
//       right: '2.5px',
//       top: '2.5px',
//       bottom: '2.5px',
//       borderLeft: border,
//       pointerEvents: 'none' /* user can't click on it */
//     }
//   };
// };
